import Component from '../component';

export default class ScrollUp extends Component {
    constructor(...args) {
        super(...args);


    }

    /*
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/scroll-up/scroll-up.js